import { useEffect, useState } from 'react';

interface AnimationOptions {
  playOnce?: boolean;
  play?: boolean;
}

function useAnimation({ play = true, playOnce = false }: AnimationOptions) {
  const [animationFinished, setAnimationFinished] = useState(false);

  useEffect(() => {
    let timeout: any = undefined;

    if (playOnce && animationFinished) {
      return;
    }

    if (play) {
      timeout = setTimeout(() => setAnimationFinished(true), 1000);
    } else {
      clearTimeout(timeout);
      setAnimationFinished(false);
    }

    return () => {
      setAnimationFinished(false);
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [play, playOnce]);
  return !animationFinished;
}

export default useAnimation;
